<template>
  <spinner-container :loading="loading">
    <back-btn/>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <rsk-factor-form
          :riskFactor="riskFactor"
          @emitRiskFactorData="update"
        />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import RskFactorForm from "@/components/risk-factor/RskFactorForm";
import { mapState } from "vuex";
import SpinnerContainer from '@/components/container/SpinnerContainer.vue';
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    RskFactorForm,
    SpinnerContainer,
    BackBtn,

  },
  data: () => ({

  }),
  computed: {
    ...mapState("RiskFactor", ["riskFactor"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    update(payload) {
      this.$store.dispatch("RiskFactor/updateRiskFactor", payload).then(() => {
        this.$router.push("/risk_factor");
      });
    },
  },
  created() {
    this.$store.dispatch("RiskFactor/getRiskFactor", this.$route.params.id);
  },
};
</script>
